import React from "react";
import { Box, Card, Text } from "grommet";
import { isPhone, toArrayOfArray } from "../../../services/utils";


const ClickableCards = ({ cards, size }) => {

    const phoneActiveStyle = { background: "#E92C70", color: '#fff'};
    const phoneInActiveStyle = { background: '#E6E6E6', color: '#a2a2a3'};

    return (
        isPhone(size) ?
            <Box justify="center" gap="small" width={'full'}>
                {toArrayOfArray(cards, 2).map((sub_cards, index) => (
                    <Box direction="row" justify="center" gap="small" width={'full'} key={index}>
                        {sub_cards.map((butt, index) => (
                            <Box style={{ width: '50%', height: 40, boxShadow: 'none', ...(butt.selected ? phoneActiveStyle : phoneInActiveStyle) }} justify='center' align='center' key={index + 1}
                                round={{ size: 'small' }} pad='small' onClick={butt.onClick}
                            >
                                <Text textAlign='center' size="small">
                                    {butt.title}
                                </Text>
                            </Box>
                        ))}
                    </Box>
                ))}
            </Box> :
        <Box direction="row" justify="center">
            {
                cards.map((card, index) => (
                    <Box key={index} pad={'small'} gap="small">
                        <Card pad={'small'} background={card.selected ? "#E92C70" : '#E6E6E6'}
                            onClick={card.onClick}
                        >
                            <Text size="small">
                                {card.title}
                            </Text>
                        </Card>
                    </Box>
                ))
            }
        </Box>
    );
};

export default ClickableCards;
